export const PRODUCTION_MODEL = { id: "claude-sonnet-4-5-20250929", name: "Claude Sonnet 4.5" } as const;
export const SONNET_4_6_MODEL = { id: "claude-sonnet-4-6", name: "Claude Sonnet 4.6" } as const;

export const EXPERIMENTAL_MODELS = [SONNET_4_6_MODEL] as const;

export const AVAILABLE_MODELS = [
  PRODUCTION_MODEL,
  ...EXPERIMENTAL_MODELS
] as const;

export type AvailableModel = typeof AVAILABLE_MODELS[number]["id"];

export const DEFAULT_CLAUDE_MODEL: AvailableModel = SONNET_4_6_MODEL.id;

export type ThinkingModeEffortLevel = "high" | "medium" | "low";

export const THINKING_MODE_TEMPERATURE = 1;

export interface ModelTokenLimits {
  maxInputTokens: number;
  maxOutputTokens: number;
  minBudgetTokens: number;
}

export const MODEL_TOKEN_LIMITS: Record<AvailableModel, ModelTokenLimits> = {
  [PRODUCTION_MODEL.id]: { maxInputTokens: 200000, maxOutputTokens: 64000, minBudgetTokens: 1024 },
  [SONNET_4_6_MODEL.id]: { maxInputTokens: 1000000, maxOutputTokens: 64000, minBudgetTokens: 1024 },
};

// Message type for chat conversations
export type Message = {
  role: "user" | "assistant";
  content: string;
};

// Tool definition for Claude API
export interface Tool {
  name: string;
  description: string;
  input_schema: {
    type: "object";
    properties: Record<string, any>;
    required?: string[];
  };
}

// Parameters for RAG queries
export interface RagQueryParams {
  query: string;
  context: unknown[];
  messages: Message[];
  systemPrompt: string;
  temperature?: number;
  onMessageDelta: (delta: string) => void;
  thinkingMode?: boolean;
  maxTokens?: number;
  budgetTokens?: number;
  effort?: ThinkingModeEffortLevel;
  model?: AvailableModel;
  onThinkingDelta?: (delta: string, type: string) => void;
  tools?: Tool[];
}

// Result type for token counting
export type TokenCountResult = {
  ok: boolean;
  tokenCount?: number;
  error?: Error;
};

// Result type for queries
export type QueryResult = {
  ok: boolean;
  response?: string;
  thinking?: string;
  usage?: any;
  toolUses?: any[];
  data?: any; // For schema-based extractions
  error?: Error;
};

// Parameters for token counting
export interface CountMessageTokensParams {
  context: unknown[];
  systemPrompt: string;
  query?: string;
  model?: AvailableModel;
}
